<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>HR Appraisal Parameter Evaluation</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" outlined />
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b>Department</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="dept" @change="getDeptInst()" :items="dept_list" item-text="name" item-value="id" label="Department" outlined />
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12" v-if="instructor_list!=''">
                        <p class="padding-bot"><b>Instructor List</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined />
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12" v-if="ay && dept && instructor">
                        <p class="padding-bot"><b></b></p>
                        <br />
                        <v-btn class="toolbar" outlined dense rounded :loading="loader" @click="fetch()"> Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <!-- {{appraisal_parameter_evaluation_list}} -->

            <v-card class="box" v-if="appraisal_parameter_evaluation_list !=''">
                <v-data-table :headers="headers" :items="appraisal_parameter_evaluation_list">
                    <template v-slot:top>
                        <v-toolbar flat class="toolbar">
                            <v-toolbar-title>HR Appraisal Parameter Evaluation</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.obtained_marks`]="{ item }">
                        <span v-if="!item.readonly">
                            <v-text-field
                                class="padding-bot"
                                outlined
                                dense
                                type="number"
                                :disabled="item.isapplicable "
                                @change="setFlag(item)"
                                v-model="item.obtained_marks"
                                :rules="[v => v <= item.max_marks || 'Marks should be Less Than Max Marks']"
                            ></v-text-field>
                        </span>
                        <span v-else>
                            <v-text-field class="padding-bot" :disabled="item.readonly" outlined dense type="number" v-model="item.obtained_marks" :rules="[v => v <= item.max_marks || 'Marks should be Less Than Max Marks']"></v-text-field>
                        </span>
                    </template>
                    <template v-slot:[`item.isapplicable`]="{ item }">
                        <span v-if="!item.readonly"> <v-checkbox dense v-model="item.isapplicable" color="success"></v-checkbox></span>
                        <span v-else>
                            --
                        </span>
                    </template>
                </v-data-table>
                <v-row justify="center" dense>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b>Max Total Score</b></p>
                        <v-text-field class="padding-bot" readonly outlined dense type="text" v-model="max_total_score"></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b>Total Score</b></p>
                        <v-text-field class="padding-bot" readonly outlined dense type="text" v-model="total_score"></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                        <p class="padding-bot"><b>Percentage</b></p>
                        <v-text-field class="padding-bot" readonly outlined dense type="text" v-model="percentage"></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-btn color="warning" @click="saveAppraisalCreditMarks()" :disabled="!this.is_final_approved  || !this.save_marks">Save</v-btn>
                </v-row>
                <br />
                <v-row justify="center" dense>
                    <v-btn color="warning" @click="saveApproveAppraisalCreditMarks()" :disabled="!this.is_final_approved  || !this.save_marks">Approve</v-btn>
                </v-row>
                <v-row justify="center" dense v-if="!this.is_final_approved">
                    <p style="color: red;">Marks Are Already Approved...</p>
                </v-row>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loader: false,
            save_marks: true,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            instructor_list: [],
            instructor: null,
            ay_list: [],
            ay: "",
            appraisal_parameter_evaluation_list: [],
            total_score: 0,
            percentage: 0,
            max_total_score: 0,
            is_final_approved: false,
            dept_list: [],
            dept: null,
            headers: [
                { text: "Sr No", value: "srno" },
                { text: "Evaluation Parameter", value: "name" },
                { text: "Max Marks", value: "max_marks" },
                { text: "Obtained Marks", value: "obtained_marks" },
                { text: "Remark", value: "remark" },
                { text: "Is Not Applicable", value: "isapplicable" },
            ],
        }),
        methods: {
            // setFlag(item){
            //   if(item.obtained_marks > item.max_marks){
            //     this.save_marks=false
            //   }else{
            //      this.save_marks=true
            //   }
            //   return this.save_marks
            // },
            setFlag() {
                // Check if any row has obtained_marks greater than max_marks
                this.save_marks = this.appraisal_parameter_evaluation_list.every((item) => item.obtained_marks <= item.max_marks);
            },
            async getDeptInst() {
                (this.instructor_list = []), (this.instructor = null);
                const data = {
                    dept: this.dept,
                };
                try {
                    const res = await axios.post("/Appraisal/getDeptInst", data);
                    if (res.data.flag == "YES") {
                        this.instructor_list = res.data.instructor_list;
                    }
                } catch (err) {
                    this.showSnackbar("red", "Something Went Wrong");
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                } finally {
                }
            },
            saveApproveAppraisalCreditMarks() {
                if (!confirm("Are You Sure You Want To Approve...?")) return;
                this.total_score = 0;
                this.max_total_score = 0;
                var evaPra_id = [];
                var evaPra_marks = [];
                for (var i = 0; i < this.appraisal_parameter_evaluation_list.length; i++) {
                    if (this.appraisal_parameter_evaluation_list[i].readonly == false) {
                        //|| this.appraisal_parameter_evaluation_list[i].readonly == true
                        if (!this.appraisal_parameter_evaluation_list[i].isapplicable == true) {
                            //|| this.appraisal_parameter_evaluation_list[i].readonly == true
                            evaPra_id.push(this.appraisal_parameter_evaluation_list[i].evaPra_id);
                            evaPra_marks.push(this.appraisal_parameter_evaluation_list[i].obtained_marks);
                            //this.total_score += parseFloat(this.appraisal_parameter_evaluation_list[i].obtained_marks);
                            //this.max_total_score += parseFloat(this.appraisal_parameter_evaluation_list[i].max_marks);
                        }
                    }
                }
                this.calculatemarks();
                const formData = {
                    ay: this.ay,
                    instructor: this.instructor,
                    total_score: this.total_score,
                    max_total_score: this.max_total_score,
                    evaPra_id: evaPra_id,
                    evaPra_marks: evaPra_marks,
                };
                axios
                    .post("/Appraisal/saveApproveAppraisalCreditMarks", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.appraisal_parameter_evaluation_list = res.data.appraisal_parameter_evaluation_list;
                            this.max_total_score = res.data.cumulative_max_marks;
                            this.total_score = res.data.cumulative_obtained_marks;
                            this.percentage = res.data.percentage;
                            this.is_final_approved = res.data.allowed_save;
                            this.showSnackbar("green", "Marks Approved Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                    });
            },
            calculatemarks() {
                this.total_score = 0;
                this.max_total_score = 0;

                let authority_obtained_total = 0;
                let authority_max_total = 0;
                let authority_count = 0;

                // First pass: Calculate authority type average
                for (let item of this.appraisal_parameter_evaluation_list) {
                    if (item.isauthoritytype === true && item.donotconsiderincalculation === false && item.isapplicable !== true) {
                        authority_obtained_total += parseFloat(item.obtained_marks) || 0;
                        authority_max_total += parseFloat(item.max_marks) || 0;
                        authority_count++;
                    }
                }

                // Add average of authority items to total
                if (authority_count > 0) {
                    this.total_score += authority_obtained_total / authority_count;
                    this.max_total_score += authority_max_total / authority_count;
                }

                // Second pass: Add non-authority items
                for (let item of this.appraisal_parameter_evaluation_list) {
                    if (item.isauthoritytype === false && item.donotconsiderincalculation === false && item.isapplicable !== true) {
                        this.total_score += parseFloat(item.obtained_marks) || 0;
                        this.max_total_score += parseFloat(item.max_marks) || 0;
                    }
                }
            },

            saveAppraisalCreditMarks() {
                var evaPra_id = [];
                var evaPra_marks = [];
                this.total_score = 0;
                this.max_total_score = 0;
                for (var i = 0; i < this.appraisal_parameter_evaluation_list.length; i++) {
                    if (this.appraisal_parameter_evaluation_list[i].readonly == false) {
                        //|| this.appraisal_parameter_evaluation_list[i].readonly == true
                        if (!this.appraisal_parameter_evaluation_list[i].isapplicable == true) {
                            //|| this.appraisal_parameter_evaluation_list[i].readonly == true
                            evaPra_id.push(this.appraisal_parameter_evaluation_list[i].evaPra_id);
                            evaPra_marks.push(this.appraisal_parameter_evaluation_list[i].obtained_marks);
                            //this.total_score += parseFloat(this.appraisal_parameter_evaluation_list[i].obtained_marks);
                            //this.max_total_score += parseFloat(this.appraisal_parameter_evaluation_list[i].max_marks);
                        }
                    }
                }
                this.calculatemarks();
                // alert("max_total_score--"+max_total_score)
                // alert("total_score--"+total_score)
                // return
                const formData = {
                    ay: this.ay,
                    instructor: this.instructor,
                    evaPra_id: evaPra_id,
                    evaPra_marks: evaPra_marks,
                    total_score: this.total_score,
                    max_total_score: this.max_total_score,
                };
                axios
                    .post("/Appraisal/saveAppraisalParameterEvaluation", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.appraisal_parameter_evaluation_list = res.data.appraisal_parameter_evaluation_list;
                            this.max_total_score = res.data.cumulative_max_marks;
                            this.total_score = res.data.cumulative_obtained_marks;
                            this.percentage = res.data.percentage;
                            this.showSnackbar("green", "Marks Saved Successfully...");
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                    });
            },

            calculate_total_percentage() {
                this.total_score = 0;
                var max_total = 0;
                var isapproved = false;
                for (var i = 0; i < this.appraisal_parameter_evaluation_list.length; i++) {
                    this.total_score += parseFloat(this.appraisal_parameter_evaluation_list[i].obtained_marks);
                    max_total += parseFloat(this.appraisal_parameter_evaluation_list[i].max_marks);
                }
            },

            fetch() {
                this.overlay = true;
                this.loader = true;
                const formData = {
                    ay: this.ay,
                    instructor: this.instructor,
                };
                axios
                    .post("/Appraisal/fetchAppraisalParameterEvaluationData", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.appraisal_parameter_evaluation_list = res.data.appraisal_parameter_evaluation_list;
                            this.max_total_score = res.data.cumulative_max_marks;
                            this.total_score = res.data.cumulative_obtained_marks;
                            this.percentage = res.data.percentage;
                            this.is_final_approved = res.data.allowed_save;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("red", res.data.snackbar);
                        } else {
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                        // this.calculate_total_percentage()
                    });
            },
            onLoad() {
                axios
                    .post("/Appraisal/getHrEvaluationData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            // this.instructor_list=res.data.instructor_list
                            this.ay_list = res.data.ay_list;
                            this.ay = res.data.cay;
                            this.dept_list = res.data.dept_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped></style>
